<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">企业充值记录</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        说明：企业充值只限企业支付类型为“预付”，如需申请充值，请点击页面客服图标联系服务商
      </div>
    </div>
    <div class="filter-box">
      <div class="bottom">
        <span class="subtitle">查询时间:</span>
        <DatePicker
          type="date"
          v-model="companyPage.start"
          placeholder="开始时间"
          style="width: 120px; margin-left: 10px"
        ></DatePicker>
        <span style="margin: 0 5px">至</span>
        <DatePicker
          type="date"
          v-model="companyPage.end"
          placeholder="结束时间"
          style="width: 120px; margin-right: 10px"
        ></DatePicker>

        <span class="btn-filter" @click="getData">查询</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>
    <Table :data="companyData" :columns="companyColumns" />
    <div class="t-right">
      <Page
        @on-change="companyPageChange"
        @on-page-size-change="companySizeChange"
        :total="companyTotal"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <div class="float-box">
      <img
        class="icon float-service"
        style="margin-top: 15px"
        src="../../assets/images/ic_float_service.png"
        @mouseover="service_show = true"
        @mouseleave="service_show = false"
      />
      <div class="float-service-box" v-if="service_show">
        <div class="title">联系服务商</div>
        <a href="tel:4001886966">
          <div class="content">{{ company.agent_tel }}</div></a
        >
        <div class="title">邮件帮助</div>
        <a href="mailto:support@aidprint.com"
          ><div class="content email">{{ company.agent_email }}</div></a
        >
      </div>
    </div>
    <Modal width="90%" v-model="visible" title="预览">
      <div style="width: 100%; text-align: center">
        <img :src="img" style="max-width: 100%" />
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
import { verifyDate, monDiff } from "@/libs/util";
export default {
  data() {
    return {
      service_show: false,
      companyData: [],
      companyColumns: [
        {
          key: "create_time",
          title: "充值时间",
          render: (h, data) => {
            return h("span", this.$moment(data.row.create_time));
          },
        },
        { key: "money", title: "充值金额" },
        { key: "agent", title: "服务商" },
        { key: "log", title: "备注" },
        // {
        //   key: "img",
        //   title: "凭证",
        //   render: (h, data) => {
        //     return h("img", {
        //       attrs: { src: this.url + data.row.img },
        //       style: {
        //         width: "40px",
        //         height: "40px",
        //         display: data.row.img ? "block" : "none",
        //       },
        //       on: {
        //         click: () => {
        //           this.img = this.url + data.row.img;
        //           this.visible = true;
        //         },
        //       },
        //     });
        //   },
        // },
        // {
        //   key: "is_confirm",
        //   title: "确认",
        //   render: (h, data) => {
        //     return h(
        //       "span",
        //       { style: { color: data.row.is_confirm ? "#19be6b" : "#ff9900" } },
        //       data.row.is_confirm ? "已确认" : "未确认"
        //     );
        //   },
        // },
      ],
      companyTotal: 0,
      companyPage: {
        p: 0,
        l: 10,
        type: 1,
        start: "",
        end: "",
      },
      date: [],
      img: "",
      visible: false,
      startOptions: {
        disabledDate: (date) => {
          let data = this.companyPage.end == "" ? Date.now() : this.companyPage.end;
          return date >= data;
        },
      }, //开始日期设置
      endOptions: {
        // 指定终止日期
        disabledDate: (date) => {
          let data = this.companyPage.start == "" ? "" : this.companyPage.start;
          return date < data;
        },
      }, //结束日期设置
    };
  },
  methods: {
    companySizeChange(l) {
      this.staffPage.l = l;
      this.getData();
    },
    companyPageChange(p) {
      this.staffPage.p = p - 1;
      this.getData();
    },
    getData() {
      if (this.companyPage.start && this.companyPage.end) {
        if (verifyDate(this.companyPage.start, this.companyPage.end)) {
          this.$Message.error("开始时间不能大于结束时间");
          return;
        }
        if (monDiff(this.companyPage.start, this.companyPage.end) > 3) {
          //如果时间跨度超过一年就提示
          this.$Message.error("筛选的时间跨度不能超过3个月");
          return;
        }
        (this.companyPage.start = this.$moment(this.companyPage.start, "YYYY-MM-DD")),
          (this.companyPage.end = this.$moment(this.companyPage.end, "YYYY-MM-DD"));
      }
      this.GetRechargeLog(this.companyPage).then((res) => {
        this.companyData = res.data;
        this.companyTotal = res.total;
      });
    },
    deleteRechargeLog(id) {
      this.DeleteRechargeLog({ id }).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        res.status && this.getData();
      });
    },
    reset() {
      this.staffPage = {
        p: 0,
        l: 10,
        type: 0,
        start: "",
        end: "",
        search: "",
      };
      this.companyPage.start = "";
      this.companyPage.end = "";
      this.getData();
    },
    exportData(is_all) {
      let title = [],
        key = [],
        columns = this.staffColumns;
      columns.map((item) => {
        let itemKey = item.key;
        title.push(item.title);
        key.push(itemKey);
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "企业充值记录",
      };
      if (is_all) {
        let start, end;
        if (this.date.length > 0) {
          (start = this.$moment(this.companyPage.start, "YYYY-MM-DD")),
            (end = this.$moment(this.companyPage.end, "YYYY-MM-DD"));
        }
        this.GetRechargeLog({
          p: this.page.p,
          l: 200000,
          type: 0,
          start,
          end,
        }).then((res) => {
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.excelData(this.staffData);
        excel.export_array_to_excel(params);
      }
    },
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      result.map((item) => {
        item.create_time = this.$moment(item.create_time);
      });
      return result;
    },
    ...mapActions(["GetRechargeLog", "DeleteRechargeLog"]),
  },
  mounted() {
    this.getData();
  },
  computed: mapGetters({
    company: "company",
  }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
